<script>
    import { handleRadioClick } from '../store.js';
    export let name;
    export let icon;
    export let instruction;
    export let id;
    export let idName;
  
    let selected = false;
    let currentRadio;
  
    function onRadioClick(event) {
      const radio = event.target;
      const radios = document.getElementsByName(radio.name);
      handleRadioClick(name, idName);
  
      for (let i = 0; i < radios.length; i++) {
        const label = radios[i].closest('label');
        if (radios[i].checked) {
          currentRadio = radios[i];
          label.classList.add('selected');
        } else {
          label.classList.remove('selected');
        }
      }
    }
  </script>

<label for={idName + '-' + id} class:selected={selected}>
    <img src={icon.url} alt={icon.alt}>
    <input required type="radio" name={idName} id={idName + '-' + id} on:click={onRadioClick} >
    <div>
      <span>{name}</span>
      {#if instruction}
      <p>{instruction}</p>
      {/if}
    </div>
  </label>


<style>
    label {
        position: relative;
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
        flex-direction: column;
        gap: 15px;
        padding: 20px;
        background: rgba(0,63,49,.1);
        border: 1px solid transparent;
        transition: all .3s ease-in;
        border-radius: 8px;
    }
    
    label:hover {
        cursor: pointer;
        background-color: rgba(0,63,49,.08);

    }
    
    label.selected {
        background: white;
        border: 1px solid #CA1E22;
    }

    label span {
        font-size: 16px;
        font-weight: 700;
        font-family: 'Poppins',Helvetica,Arial,Lucida,sans-serif;
        color: #003f31;
    }
    label div {
      text-align: center;
    }
    label p {
      max-width: 210px;
      font-size: 14px;
      color: #003f31;
      margin-bottom: 0;
      margin-top: 5px;
    }
    input[type=radio] {
        appearance: none;
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        background: transparent;
        border: 2px solid rgba(0,63,49,.1);
    }
    input[type=radio]::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9.763' height='6.716' viewBox='0 0 9.763 6.716'%3E%3Cpath id='Path_238' data-name='Path 238' d='M220.246,241.494l2.84,2.84,5.509-5.509' transform='translate(-219.539 -238.118)' fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='1'/%3E%3C/svg%3E%0A");
        position: absolute;
        width: 90%;
        height: 90%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
    }
    input[type=radio]:checked {
        background: #CA1E22;
        border: 2px solid #CA1E22;
    }

    input[type=radio]:checked::after {
        opacity: 1;
    }

</style>